<script lang="ts" setup>
const props = defineProps<{
  name?: string
  defaultClosed?: boolean | undefined
  headerClass?: string
  className?: Record<string, boolean>
  dynamicHeight?: boolean
}>()

const items = computed(() => [
  {
    label: props.name ?? 'accordion',
    defaultOpen: !props.defaultClosed,
  },
])
</script>

<template>
  <div
    :key="`accordion-${!!props.defaultClosed}`"
    :class="{
      collapsible: true,
      dynamic: props.dynamicHeight,
      ...props.className,
    }">
    <UAccordion
      :items="items"
      :default-open="!props.defaultClosed"
      :ui="{
        item: {
          base: 'collapsible-item text-text1',
        },
        wrapper: 'collapsible-wrapper h-full',
        container: `collapsible-container h-full ${props.headerClass ?? ''}`,
      }">
      <template #default="{ open }">
        <div
          class="collapsible-header flex w-full items-center"
          :class="{
            '-active': open,
          }">
          <slot name="header" :open="open" />
          <div class="ml-auto">
            <i class="icon" />
          </div>
        </div>
      </template>

      <template #item="{}">
        <div class="collapsible-body">
          <slot />
        </div>
      </template>
    </UAccordion>
  </div>
</template>

<style lang="postcss" scoped>
.collapsible {
  @apply w-full;

  .collapsible-header {
    padding: 1rem;
    font-weight: 700;
    cursor: pointer;
    width: 100%;
    gap: 1rem;

    .icon {
      position: relative;
      margin-left: auto;
      font-family: theme('vars.fontAwesome');
      font-weight: 900;
      font-style: normal;
      line-height: 1;
      background-color: transparent;
      mask-image: none;

      &:before {
        display: flex;
        align-items: center;
        justify-content: center;
        content: '\f104';
        position: relative;
        width: 100%;
        height: 100%;
        transform: rotate(-90deg);
        transition: all 0.2s linear;
      }
    }

    &.-active {
      .icon {
        &:before {
          transform: rotate(-270deg);
        }
      }
    }
  }

  &.dynamic {
    :deep(.v-enter-to) {
      height: auto !important;
    }
  }
}
</style>
